module.exports = __webpack_public_path__ + "img/leader-notice.7db9a5bc.svg";